import { detect } from 'detect-browser'
const browser = detect()

const getRelayTarget = function (el) {
  return (el && ((el.dataset && el.dataset.scrollRelay) || (el.parentElement && getRelayTarget(el.parentElement)))) || null
}

const relayEventWrapper = function (eventHandler, evt) {
  let relayTarget
  const relay = getRelayTarget(evt.target)
  if (relay && (relayTarget = document.querySelector(relay))) {
    eventHandler(relayTarget, evt)
  }
}

const relayEvent = function (relayTarget, evt) {
  const { wheelDelta, wheelDeltaX, wheelDeltaY, deltaX, deltaY, deltaZ } = evt
  const e = new evt.constructor(evt.type, { wheelDelta, wheelDeltaX, wheelDeltaY, deltaX, deltaY, deltaZ })
  relayTarget.dispatchEvent(e)
}

const handleDOMMouseScroll = function (relayTarget, evt) {
  const scrollAmount = evt.detail || (-evt.wheelDelta / 40)
  relayTarget.scrollTop = relayTarget.scrollTop + 1.5 * scrollAmount // magic but it works
}

switch (browser.name) {
  case 'firefox':
    window.addEventListener('MozMousePixelScroll', relayEventWrapper.bind(null, handleDOMMouseScroll), { passive: true })
    break
  case 'ie':
    window.addEventListener('mousewheel', relayEventWrapper.bind(null, handleDOMMouseScroll), { passive: true })
    break
  default:
    window.addEventListener('wheel', relayEventWrapper.bind(null, relayEvent), { passive: true })
    break
}
